module.exports = __webpack_public_path__ + "static/cmh_grayscaled-5e2161d8a6637e3a9ffbcd5c4ce934c9.png";